import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import ajjanathota from "../../Assets/Projects/ajjanathota.png";
import modular_robotics from "../../Assets/Projects/cv2d.jpg";
import exomy from "../../Assets/Projects/exomy.jpg";
import mpfav from "../../Assets/Projects/mpfav.png";
import portfolio from "../../Assets/Projects/portfolio.png";
import imitation_learning from "../../Assets/Projects/ImitationLearning.gif"
import chef_pp from "../../Assets/Projects/chef++.jpeg"
import stuwerk_tracks from "../../Assets/Projects/stuwerk-tracks.jpeg"


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works | Page still Work-In-Progress</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={'https://img.youtube.com/vi/VZBvFfCQiZ0/0.jpg'}
              isBlog={false}
              title="FellowUp"
              description="Hackathon : Project aims to help the Start Fellowship monitor progress of current and alumni startups and foster social connections and collaborations between changemakers with common goals."
              link="https://github.com/Prashanth-HR/FellowUp"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={stuwerk_tracks}
              isBlog={false}
              title="Stuwerk Tracks"
              description="Hackathon : Implement a portal for autonomous driving testbed booking and simulate driving secanrios."
              link="https://github.com/Prashanth-HR/RTSH"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chef_pp}
              isBlog={false}
              title="Chef++"
              description="Hackathon : Automated Kaiserschmarn cooking machine that won the Best Prototype Award at Circular Republic Hackfest"
              link="https://youtu.be/cxGDH8NSzCY"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={imitation_learning}
              isBlog={false}
              title="Master Thesis - Imitation Learning"
              description="Implement a pipeline which executes object Approach followed by object Interaction to perform gearbox assembly task. Use Coarse to Fine Imitation Learning approach to learn the gear-assembly task from a single human demonstration using RealSense camera."
              link="https://youtube.com/playlist?list=PLSSe2TLLn1zbQ9AnK7VcqynDaHSpLkrPX"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={modular_robotics}
              isBlog={false}
              title="Modular Robotics - Computer Vision 2D"
              description="Implementation of a 2D computer vision solution that enables a modular industrial robot to detect and grasp
              specific parts inside its workspace."
              link="https://youtube.com/playlist?list=PLSSe2TLLn1zZ8ZKM-Td647Yp7wbBAvE2d"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mpfav}
              isBlog={false}
              title="Motion Planning for Autonomous Vehicles - CARLA Simulation"
              description="ntegration of autonomous simulation platform CARLA with the existing Common-Road interface.The
              Ego-Vehicle in Carla follows the trajectory generated by the Motion Planning Algorithm implemented in
              CommonRoad."
              link="https://youtube.com/playlist?list=PLSSe2TLLn1zYGrYQyrd4xnZgjoVJfnDHy"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={exomy}
              isBlog={false}
              title="TUM WARR Exploration - Building ESA Exomy"
              description="3D print the Exomy model parts, assemble the model along with motors and electronic circuits. Integration of
              User-Interface to control the rover. The Exomy has some inbuilt drive modes (like Crabbing, Ackermann, Deployment etc..). The user-interface is used
              to switch between drive modes and control the speed of the motors"
              link="https://youtube.com/playlist?list=PLSSe2TLLn1zb7XMXqusSm_gNDUxR_FLEl"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ajjanathota}
              isBlog={false}
              title="E-Commerce Website -> AjjanaThota"
              description="Built a simple e-commerce website where the customers can browse for products and add to their carts. Users can checkout, pay, order the products in a single flow."
              link="http://ajjanathota.tk/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="Personal PortFolio/Website"
              description="A simple Personal Webportal built using ReactJS and hosted on Github pages."
              link="https://prashanth-hr.github.io/PortFolio/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
